import { type FunctionComponent } from 'react';
import { PAGE_CONTENT_STYLE } from '../../../constants/general';
import { SUPPORT_EMAIL_US_LINK } from '../../../constants/links';
import { useContactInfo } from '../../../hooks/apollo/site/site.hooks';
import { StyledLink } from '../../common-components/link/styled-link.component';
import { Status } from '../../status';

export const ProductNotFound: FunctionComponent = () => {
	const {
		phone: { number: phoneNumber }
	} = useContactInfo();

	return (
		<Status code={404}>
			<div className={PAGE_CONTENT_STYLE} data-testid={'product-404-content'}>
				<h1>Thank you for shopping at Ferguson Home</h1>
				<p>
					The product you requested from our site could not be found or has been discontinued. If you're sure the product exists,
					please call our <StyledLink url={SUPPORT_EMAIL_US_LINK}>customer service</StyledLink> center at{' '}
					<span>{phoneNumber}</span> to see if we can add it while you're browsing our site.
				</p>
				<h2>Need help?</h2>
				<ul>
					<li>
						<StyledLink url={SUPPORT_EMAIL_US_LINK}>Email Us</StyledLink>
					</li>
					<li className="mt2">
						Call <span>{phoneNumber}</span>
					</li>
				</ul>
			</div>
		</Status>
	);
};
